// extracted by mini-css-extract-plugin
module.exports = {"layoutWrapperMain":"styles_layoutWrapperMain__1Z3W5","root":"styles_root__xj95l","container":"styles_container__21CJQ"};